<template xmlns:50px>
  <div class="page-container">
    <div style="margin-left: 20px;margin-top: 20px">
      <el-radio-group v-model="showType" @change="showTypeChange">
        <el-radio-button label="0">精诊展示效果</el-radio-button>
        <el-radio-button label="-1">深总医院效果</el-radio-button>
        <el-radio-button label="-2">山东省立</el-radio-button>
        <el-radio-button label="-3">精诊模板-3</el-radio-button>
        <el-radio-button label="-4">精诊模板-4</el-radio-button>
      </el-radio-group>
    </div>
    <div class="filter-container">
      <el-form size="small" :inline="true">
        <el-form-item :label="item.label" v-for="item in stlConfigAllFilter" :key="item.label">
          <el-input v-model="form[item.prop]"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="onReset">清空</el-button>
          <el-button type="primary" @click="handleAdd">添加部件</el-button>
          <el-button type="primary" @click="handleAddGroup">添加分组</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container" style="text-align: center">
      <el-table stripe
                :data="tableData"
                lazy
                :load="query"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                row-key="key"
                size="small">
        <el-table-column :label="item.label" v-for="item in stlConfigAllTable" :key="item.label">
          <template slot-scope="scope">

            <template v-if="scope.row.isGroup">
              <span v-if="item.prop==='group'">{{ scope.row.name }}
                <!--                <img style="width: 30px;height: 30px" :src="scope.row.url" alt="logo">-->
              </span>
              <span v-else-if="item.prop==='sort'">{{ scope.row[item.prop] }}</span>
              <span v-else-if="item.prop==='tag'">--</span>
              <span v-else-if="item.filter">{{ item.filter(scope.row) }}</span>
              <span v-else>--</span>
            </template>

            <template v-else-if="!scope.row.isGroup">
              <span v-if="item.prop==='group'"></span>
              <span v-else-if="item.prop==='color'" v-html="item.filter(scope.row)"></span>
              <span v-else-if="item.filter">{{ item.filter(scope.row) }}</span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>

          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <template v-if="scope.row.isGroup">
              <el-button type="text" size="small" @click="handleEditGroup(scope.row)"
                         style="margin-right: 20px">编辑
              </el-button>
              <el-button type="text" size="small" @click="handleAdd(scope.row)"
                         style="margin-right: 20px">添加部件
              </el-button>
              <el-popconfirm
                title="是否删除此分组？删除后，当前分组内的部件将默认解除分组，并显示在默认分组"
                @onConfirm="handleDeleteGroup(scope.row.id)"
              >
                <el-button type="text" size="small" slot="reference" style="margin-right: 20px">刪除</el-button>
              </el-popconfirm>
            </template>

            <template v-if="!scope.row.isGroup">
              <el-button type="text" size="small" @click="handleEdit(scope.row, 'edit')" style="margin-right: 20px">编辑
              </el-button>
              <el-popconfirm
                title="确定要删除这个部件吗？删除后，部件列表将彻底删除此部件。"
                @onConfirm="handleDelete(scope.row.id)"
              >
                <el-button type="text" size="small" slot="reference" style="margin-right: 20px">刪除</el-button>
              </el-popconfirm>
            </template>

          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="stl-add">
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" center>
        <el-form size="small" ref="editForm" :model="editForm" :inline="true">
          <el-form-item label="模型名">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="选择颜色">
            <el-color-picker
              v-model="editForm.color"
              color-format="rgb"
              :predefine="predefineColors">
            </el-color-picker>
          </el-form-item>
          <!--          <el-form-item label="是否显示">-->
          <!--            <el-radio-group v-model="editForm.show">-->
          <!--              <el-radio-button :label="0">不显示</el-radio-button>-->
          <!--              <el-radio-button :label="1">显示</el-radio-button>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
          <el-form-item label="自定义不透明度">
            <el-input-number v-model="editForm.middle" :min="1" :max="99"
                             @change="editForm.middle=editForm.middle?editForm.middle:1;editForm.opacity=editForm.opacity>0&&editForm.opacity<100?editForm.middle:editForm.opacity;"
                             style="width: 50%"></el-input-number>
          </el-form-item>
          <el-form-item label="不透明度">
            <el-radio-group v-model="editForm.opacity">
              <el-radio-button :label="0">透明</el-radio-button>
              <el-radio-button :label="editForm.middle">{{ editForm.middle }}%</el-radio-button>
              <el-radio-button :label="100">不透明</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序值">
            <el-input-number v-model="editForm.sort" :min="1" label="1"></el-input-number>
          </el-form-item>
          <el-form-item label="选择分组">
            <el-select v-model="editForm.group" placeholder="请选择分组">
              <el-option
                v-for="item in groupData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择标签">
            <el-select v-model="editForm.tag" placeholder="请选择标签">
              <el-option
                v-for="item in tags"
                :key="item.v"
                :label="item.k"
                :value="item.v">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <span style="color: red" :v-if="tipShow">{{ tips }}</span>
          <br/>
          <el-button @click="dialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="handleSave">保存</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="group-add">
      <el-dialog :title="dialogGroupTitle" :visible.sync="dialogGroupVisible" center>
        <el-form size="small" ref="editGroupForm" :model="editGroupForm" :inline="true">
          <el-form-item label="分组名">
            <el-input v-model="editGroupForm.name"></el-input>
          </el-form-item>
          <el-form-item label="排序值">
            <el-input-number v-model="editGroupForm.sort" :min="1" label="1"></el-input-number>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-radio-group v-model="editGroupForm.show">
              <el-radio-button :label="0">不显示</el-radio-button>
              <el-radio-button :label="1">显示</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!--          <el-form-item label="分组图标（120*120）" prop="url">-->
          <!--            <el-upload-->
          <!--              class="avatar-uploader"-->
          <!--              action="/api/upload/image?path=model"-->
          <!--              :show-file-list="false"-->
          <!--              :on-success="handleAvatarSuccess"-->
          <!--              :before-upload="beforeAvatarUpload">-->
          <!--              <img v-if="editGroupForm.url" :src="editGroupForm.url" class="avatar">-->
          <!--              <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--            </el-upload>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item v-if="groupEdit" label="默认展示体积">-->
          <!--            <el-select v-model="editGroupForm.volumeModel" placeholder="请选择默认展示体积的模型">-->
          <!--              <el-option-->
          <!--                v-for="item in groupModelList"-->
          <!--                :key="item.id"-->
          <!--                :label="item.name"-->
          <!--                :value="item.id">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->

        </el-form>
        <div slot="footer" class="dialog-footer">
          <span style="color: red" :v-if="tipGroupShow">{{ tipsGroup }}</span>
          <br/>
          <el-button @click="dialogGroupVisible=false">取 消</el-button>
          <el-button type="primary" @click="handleSaveGroup">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as R from 'ramda';
import uuidv1 from 'uuid/v1';
import {stl as stlApi} from '@/api';

export default {
  name: 'stlConfigList',
  data() {
    return {
      stlConfigAllFilter: [],
      stlConfigAllTable: [],
      form: {},
      editForm: {
        opacity: '', // 透明度字符串
        sort: '1',
        tag: ''
      },
      tags: [
        {k: '无', v: null},
        {k: '轮廓', v: 0},
        {k: '血管', v: 1},
        {k: '病灶', v: 2},
        {k: '切缘', v: 3}
      ],
      verify: '',
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增',
      tipShow: false,
      tips: '',
      groupEdit: false,
      groupData: [],
      groupModelList: [],
      editGroupForm: {
        sort: '1',
        // volumeModel: ''
      },
      dialogGroupVisible: false,
      dialogGroupTitle: '新增',
      tipGroupShow: false,
      tipsGroup: '',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#c58588'
      ],
      showType: '0'
    };
  },
  computed: {
    operates: ({$route}) => $route.meta.operates,
  },
  methods: {
    // list 点击添加按钮
    handleAdd(row) {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
      this.editForm = {
        opacity: 100,
        sort: '1',
        group: this.groupData[0].id
      };
      if (row.id) {
        this.editForm.group = row.id;
      }
    },
    async handleSave() {
      if (!this.editForm.name) {
        this.tipShow = true;
        this.tips = '模型名不能为空';
        return;
      }
      if (!this.editForm.color) {
        this.tipShow = true;
        this.tips = '颜色不能为空';
        return;
      }
      this.tipShow = false;
      this.tips = '';
      this.editForm.color = this.editForm.color.replace('rgb(', '').replace(')', '').replace(' ', '').replace(' ', '');
      this.editForm.orderId = this.showType;
      let data;
      // 有id 修改
      if (this.editForm.id) {
        data = await stlApi.update(this.editForm);
      } else {
        // 没id 新增
        data = await stlApi.add(this.editForm);
        if (!data) return;
      }
      if (data.code === 10000) {
        this.$message.success('成功！');
        this.onSearch();
        this.dialogVisible = false;
      } else {
        if (data.code === 61004) {
          this.$confirm(`模型名称在其他分组已存在，是否继续添加？`, '提示', {}).then(() => {
            this.editForm.ignoreName = true;
            this.handleSave();
          }).catch(console.log);
        }
        this.tipShow = true;
        this.tips = data.msg;
      }
    },
    // list 点击编辑
    async handleEdit(row, pageType) {
      this.dialogVisible = true;
      this.dialogTitle = '编辑';
      const data = await stlApi.detail(row.id);
      if (!data) return;
      if (data.code === 10000) {
        this.editForm = data.data;
        this.editForm.color = `rgb(${this.editForm.color})`;
      }
    },

    handleDelete(id) {
      stlApi.delete(id)
        .then((res) => {
          if (res.code === 10000) {
            this.$message.success('删除成功！');
            this.onSearch();
          }
        });
    },

    handleAddGroup() {
      this.dialogGroupVisible = true;
      this.dialogGroupTitle = '新增';
      this.groupEdit = false;
      this.editGroupForm = {
        sort: '1'
      };
    },
    async handleSaveGroup() {
      if (!this.editGroupForm.name) {
        this.tipGroupShow = true;
        this.tipsGroup = '分组名不能为空';
        return;
      }
      this.tipGroupShow = false;
      this.tipsGroup = '';
      this.editGroupForm.orderId = this.showType;
      // this.editGroupForm.url = 'http://dppublic.oss-cn-beijing.aliyuncs.com/model/icon_operation_3x.png';
      let data;
      // 有id 修改
      if (this.editGroupForm.id) {
        data = await stlApi.updateGroup(this.editGroupForm);
      } else {
        // 没id 新增
        data = await stlApi.addGroup(this.editGroupForm);
        if (!data) return;
      }
      if (data.code === 10000) {
        this.$message.success('成功！');
        this.queryGroup();
        this.dialogGroupVisible = false;
      } else {
        this.tipGroupShow = true;
        this.tipsGroup = data.msg;
      }
    },
    // 点击编辑分组
    handleEditGroup(row) {
      this.query(row);
      // this.editGroupForm.volumeModel = row.volumeModel;
      this.dialogGroupVisible = true;
      this.dialogGroupTitle = '编辑';
      this.groupEdit = true;
      this.editGroupForm = row;
      this.editGroupForm.show = row.show;
    },
    handleDeleteGroup(id) {
      stlApi.deleteGroup(id, 0)
        .then((res) => {
          if (res.code === 10000) {
            this.$message.success('删除成功！');
            this.queryGroup();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // handleAvatarSuccess(res) {
    //   this.editGroupForm.url = res.data;
    // },
    // beforeAvatarUpload(file) {
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //
    //   if (!isLt2M) {
    //     this.$message.error('上传图片大小不能超过 2MB!');
    //   }
    //   return isLt2M;
    // },

    // 显示模式切换
    showTypeChange(val) {
      this.queryGroup();
    },

    getForm() {
      const {stlConfigAllFilter} = this.$route.meta;
      const form = {};
      R.forEach(({prop}) => {
        form[prop] = '';
      }, stlConfigAllFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const {onClick} = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const {stlConfigAllFilter, stlConfigAllTable} = this.$route.meta;
      this.stlConfigAllFilter = stlConfigAllFilter;
      this.stlConfigAllTable = stlConfigAllTable;
      this.getForm();
      this.queryGroup();
    },
    onSearch() {
      this.query();
    },
    async queryGroup() {
      const submitForm = {orderId: this.showType};
      const res = await stlApi.listGroup(submitForm);
      if (res.code === 10000) {
        const {data} = res;
        this.groupData = [];
        data.forEach(e => {
          this.groupData.push({
            id: e.id,
            name: e.name
          });
          e.key = uuidv1();
          e.isGroup = true;
          e.hasChildren = true;
        });
        this.tableData = data;
      }
    },

    /**
     * 查询分组下模型
     */
    async query(row, treeNode, resolve) {
      let submitForm = {};
      // 点击展开时
      if (row) {
        submitForm['group'] = row.id;
      } else {
        // 点击查询时
        submitForm = this.form;
        if (!submitForm.name) {
          this.queryGroup();
          return;
        }
      }
      submitForm.orderId = this.showType;
      const res = await stlApi.list(submitForm);
      if (res.code === 10000) {
        const {data} = res;
        data.forEach(e => {
          e.key = uuidv1();
          e.isGroup = false;
          e.hasChildren = false;
          // e.opacity = Number(e.opacity) === 0 ? 0 : (Number(e.opacity) === 100 ? 100 : 50);
        });
        if (row) {
          this.groupModelList = data;
          if (resolve) {
            resolve([
              ...data
            ]);
          }
        } else {
          this.tableData = data;
        }
      }
    },
    // onPageChange(pageNo) {
    //   this.query(pageNo);
    // },

  },
  created() {
    this.onCreated();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  }
};
</script>

<style lang="scss">
.stl-add {

  .el-tag.el-tag--info {
    color: white;
  }

  .el-select .el-tag {
    background-color: #222933;
  }
}
</style>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 20px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/view/stlConfig/index.vue